/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario de proveedores.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
* ---------------------------------------------------------------------------------------
*/

import FrmProveedores from "../../../catalogos/proveedores/FrmProveedores.jsx";
import SizeSoftXFrmPortatil from "../../leyout/SizeSoftXFrmPortatil.jsx";

export default function FrmProveedoresPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmProveedores">
      <FrmProveedores />
    </SizeSoftXFrmPortatil>
  );
}
